import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";


const NamePublicationAdminReport = () => {
    const [publicationData, setPublicationData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        const fetchPublicationData = async () => {
            try {
                // Retrieve token from localStorage or sessionStorage
                const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

                const response = await fetch(`${API_BASE_URL}/NamePublication/GetPublicationRecords`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${authToken}`, // Attach token in the request

                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                // Add SrNo property to each record
                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1 // Auto-incrementing SrNo
                }));

                setPublicationData(data); // Update state with modified data
            } catch (error) {
                console.error('Failed to fetch publication records:', error);
            }
        };

        fetchPublicationData();
    }, []);

    console.log(publicationData);

    // Function to update status
    const handleStatusChange = async (registrationNo, newStatus) => {
        const comment = prompt("Enter comment for this status change:");
        if (!comment) return; // Optional: require comment

        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/NamePublication/updateStatus/${registrationNo}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ status: newStatus, comment }),
            });

            if (!response.ok) throw new Error("Failed to update status");

            // Update UI state
            setPublicationData(prev =>
                prev.map(row =>
                    row.registrationNo === registrationNo
                        ? { ...row, status: newStatus, comment }
                        : row
                )
            );

        } catch (error) {
            console.error("Error updating status:", error);
        }
    };
    const generatePDF = (record) => {
        const doc = new jsPDF("p", "pt", "a4");

        const content = `
            <div class="paper" style="padding: 40px; font-family: sans-serif;">
                <h3 style="text-align: center; color: #333;">CHAKRAN MULTI SERVICES PVT LTD</h3>
                <h4 style="text-align: center; border-bottom: 2px solid #333; padding-bottom: 10px;">NAME PUBLICATION APPLICATION</h4>
                
                <div style="display: flex; justify-content: space-between; margin-top: 20px;">
                    <div>Registration No: <strong>${record.registrationNo || "-"}</strong></div>
                    <div>Date: <strong>${record.startDate || "-"}</strong></div>
                </div>

                <div style="margin-top: 30px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold; width: 30%;">Category</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.checkedOption || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Date of Birth</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.date || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Reason</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.reason || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Old Name</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.oldFirstName} ${record.oldMiddleName || ""} ${record.oldLastName || ""}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">New Name</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.newFirstName} ${record.newMiddleName || ""} ${record.newLastName || ""}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Address</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.address || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Pin Code</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.pinCode || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Mobile No</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.mobileNo || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">District / State</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.district || "-"}</td>
                        </tr>
                        <tr>
                            <td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">Tahsil / Village</td>
                            <td style="padding: 8px; border: 1px solid #ddd;">${record.tahsil || "-"} / ${record.village || "-"}</td>
                        </tr>
                    </table>
                </div>

                <div style="margin-top: 50px;">
                    <p>Office Address: Shop No.5, Shanti Nagar Dongari, Near Canara Bank, S V Road, Dahisar East, Mumbai - 400068</p>
                    <p>Mobile No.: 9967318555 | Email Id: support@chakran.in</p>
                    <div style="margin-top: 40px; text-align: right;">
                        <p>For, CHAKRAN MULTI SERVICES PVT LTD</p>
                        <br/><br/>
                        <p>Authorized Signatory</p>
                    </div>
                </div>
            </div>
        `;

        doc.html(content, {
            callback: function (doc) {
                doc.save(`NamePublication_${record.registrationNo}.pdf`);
            },
            x: 10,
            y: 10,
            html2canvas: { scale: 0.55 },
        });
    };


    useEffect(() => {
        if (tableRef.current && publicationData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true, // Destroy existing table instance
                data: publicationData,
                columns: [
                    { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
                    { data: 'startDate', title: 'Date' }, // Matches 'startDate'
                    { data: 'name', title: 'Applicant Name' }, // Matches 'name'
                    { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data, type, row) {
                            return `
                      <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                        <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                        <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                        <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                        <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                        </select>
                    `;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Submitted Form",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "Document",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "Upload Receipt",
                        render: (data, type, row) => `
                     <input type='file' class='file-input' data-id='${row.registrationNo}' style='display:none;' accept='.pdf,.jpg,.png,.docx'/>
                     <button class='btn btn-sm btn-warning upload-btn' data-id='${row.registrationNo}'>Upload</button>
                     
                    `,
                    },
                    //   <br/>
                    //     //  <span class='file-name text-success' data-id='${row.registrationNo}'>
                    //     //      ${row.PanReceiptPath && row.PanReceiptPath !== "" ? `📄 ${row.PanReceiptPath.split('/').pop()}` : "No file uploaded yet."}
                    //     // </span>
                ]
            });

            // Handle status change
            $(tableRef.current).on("change", ".status-dropdown", function () {
                const registrationNo = $(this).attr("data-id");
                const newStatus = $(this).val();
                const comment = ""; // Or however you get it
                handleStatusChange(registrationNo, newStatus, comment);
            });

            // Handle download button click
            $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
                const registrationNo = $(this).data("id");
                downloadPDF(registrationNo, "form");
            });

            $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
                const registrationNo = $(this).data("id");
                downloadPDF(registrationNo, "document");
            });

            // Handle Upload Button Click
            $("#productsTable tbody").off("click", ".upload-btn").on("click", ".upload-btn", function () {
                const registrationNo = $(this).data("id"); // Ensure this is a string
                $(`.file-input[data-id='${registrationNo}']`).trigger("click");
            });

            // Handle File Selection
            $("#productsTable tbody").off("change", ".file-input").on("change", ".file-input", function () {
                const registrationNo = $(this).data("id"); // Ensure this is a string
                const file = this.files[0];
                if (file) {
                    uploadFile(registrationNo, file);
                }
            });

            return () => {
                table.destroy();
                $(tableRef.current).off("change", ".status-dropdown");
            };
        }
    }, [publicationData]);

    const downloadPDF = async (registrationNo, type) => {
        try {
            const authToken = localStorage.getItem("authToken");
            const endpoint = type === "form"
                ? `${API_BASE_URL}/NamePublication/DownloadPdf/${registrationNo}`
                : `${API_BASE_URL}/NamePublication/DownloadDocument/${registrationNo}`;

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to download file: ${response.status}`);
            }

            if (type === "form") {
                // ✅ API returns JSON (data for form)
                const record = await response.json();
                console.log("📌 Name Publication API Data:", record);
                generatePDF(record);
            } else {
                // ✅ For documents, API returns blob
                const blob = await response.blob();
                const contentType = response.headers.get("Content-Type");

                // Determine file extension from MIME type
                const fileExtension = contentType.split("/")[1] || "pdf";

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `NamePublication_${type}_${registrationNo}.${fileExtension}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    // File Upload Function
    const uploadFile = async (registrationNo, file) => {
        console.log("File selected:", file.name);  // Log the file name here
        try {
            const authToken = localStorage.getItem("authToken");
            const formData = new FormData();
            formData.append("file", file);

            // ✅ Use backticks (`) for the correct API URL format
            const response = await fetch(`${API_BASE_URL}/NamePublication/upload-receipt/${registrationNo}`, {
                method: "POST",
                headers: { Authorization: `Bearer ${authToken}` }, // No 'Content-Type' for FormData
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Failed to upload file: ${response.status}`);
            }

            const data = await response.json();
            alert("✅ File uploaded successfully!");

            // ✅ Update the data state with the correct file path          

            setPublicationData((prevData) =>
                prevData.map((item) =>
                    item.registrationNo === registrationNo
                        ? { ...item, PanReceiptPath: data.FilePath } // Use consistent casing
                        : item
                )
            );


            // ✅ Force DataTable to redraw
            const table = $('#productsTable').DataTable();
            table.clear();
            table.rows.add(publicationData); // Update the table with the new data
            table.draw();

        } catch (error) {
            console.error("Upload error:", error);
            alert("❌ Failed to upload file.");
        }
    };

    return (

        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Applicant Name</th>
                    <th>Registration No</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Submitted Form</th>
                    <th>Document</th>
                    <th>Upload Receipt</th>
                </tr>
            </thead>
        </table>

    );
};

export default NamePublicationAdminReport;